export default __webpack_public_path__ + "static/bgea-554049cee01da52fe370ceee583a85e4.svg";